import { Ticket } from '../types/Ticket';
import { api } from './api.config';

export const fetchTicketsForClass = async (classId: string) => {
  const response = await api.get<Ticket[]>(`tournament/class/${classId}/tickets`);
  return response.data;
};

export const refundTicket = async (
  ticketId: number,
  reason?: string,
  amount?: number,
  notifyUser?: boolean
) => {
  const response = await api.post<{
    refundAmount: number;
    success: boolean;
    refundCurrency: string;
  }>(`stripe/refund`, {
    reason,
    amount,
    ticketId,
    notifyUser,
  });
  return response.data;
};

export const transferTicket = async (ticketId: number, newUserId: number, notifyUser?: boolean) => {
  const response = await api.post(`ticket/transfer`, { ticketId, newUserId, notifyUser });
  return response.data;
};

export const revokeTicket = async (ticketId: number, notifyUser?: boolean) => {
  const response = await api.post(`ticket/revoke`, { ticketId, notifyUser });
  return response.data;
};
